const POSITION_STYLES = {
  bottomRight: {
    right: 16,
    bottom: 16,
  },
  centerRight: {
    right: 16,
    top: '50%',
  },
  topRight: {
    top: 16,
    right: 16,
  },
}

export { POSITION_STYLES }
